import React from 'react';
import { useBackorders } from '~/hooks/backorders';

import { useCartCompany } from '~/hooks/cartCompany';
import { useClients } from '~/hooks/clients';

export function PauseOrderButton(): JSX.Element {
  const { products, clear, setProducts } = useCartCompany();
  const { saveOrder, orders, recoverOrder } = useBackorders();
  const { selectedClient, setSelectedClient } = useClients();

  function pauseOrder() {
    saveOrder({
      client: selectedClient,
      products,
    });

    clear();
  }

  function recover(index: number) {
    const order = recoverOrder(index);
    setSelectedClient(order.client);
    setProducts(order.products);
  }

  return (
    <>
      {orders.length > 0 && (
        <>
          <p className="mt-1 mb-0">Pedidos em espera</p>
          {orders.map((item, index) => (
            <button
              type="button"
              className="mt-1"
              onClick={() => recover(index)}
            >
              {`${item.client.name}`}
            </button>
          ))}
        </>
      )}

      {products.length > 0 && (
        <button type="button" className="mt-1" onClick={pauseOrder}>
          PAUSAR PEDIDO
        </button>
      )}
    </>
  );
}
